import Vue from 'vue'
import App from './App.vue'
import '@mdi/font/css/materialdesignicons.css';
import 'typeface-roboto/index.css';
import vuetify from './plugins/vuetify';
import store from './store/';
import router from './router';
import DatetimePicker from 'vuetify-datetime-picker';
import {checkApiToken, checkHealth} from '@/api/request';
import {apiProfile} from "./api/user";
import moment from 'moment';
import VCurrencyField from 'v-currency-field';
import { VTextField } from 'vuetify/lib';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';

Vue.component('v-text-field', VTextField);

Vue.config.productionTip = false;

moment.locale('de');
Vue.use(DatetimePicker);

Vue.use(VCurrencyField, {
    allowNegative: false,
    locale: 'de-DE',
    min: 0
});

Vue.use(VuetifyGoogleAutocomplete, {
    apiKey: 'AIzaSyDDQ37CQEXqQD0hddwpor7KA69QS5g7HS0',
    locale: 'de'
});

let reloadUserData = async function()
{
    let res = await apiProfile();

    if(res)
    {
        store.dispatch('user/setUser', res.data);
        store.dispatch('user/login');
    }

    store.dispatch('finishedInitialization');
};

let checkHealthInitial = async function()
{
    let canContinue = await checkHealth(true);

    if (canContinue)
    {
        if(checkApiToken())
            reloadUserData();
        else
            store.dispatch('finishedInitialization');
    }
    else
    {
        await store.dispatch('finishedInitialization');
        await store.dispatch('appNotAvailable');
        await router.push({name: 'app-not-available'}, function() {}, function() {});
    }
}

checkHealthInitial();

new Vue({
    vuetify,
    store,
    router,
    render: h => h(App)
}).$mount('#app');